import { Exceptions } from "../util/Translations"
import { IItem } from "../models"
import { ItemDTO } from "./models/fields"
import { RequestErrorDataApi } from "../errors"
import { dataAPI } from "./api"
import { formatString } from "../util/Strings"

export const getItemAncestry = async (itemId: number): Promise<IItem[]> => {
    const parents = []
    let id = itemId
    let shouldContinueSearch = true
    // Escape hatch to make sure we don't fetch never ending hierarchies
    let index = 0
    while (shouldContinueSearch && index < 10) {
        const parent = await getItemParent(id)
        if (parent === null || !parent.id) {
            shouldContinueSearch = false
        } else {
            parents.push(parent)
            id = parent.id
        }
        index++
    }
    if (index === 10 && shouldContinueSearch) {
        console.warn(
            `Stopped fetching parents for item [${itemId}] as there seems to be too many.`,
        )
    }
    return parents.reverse()
}

export const getItemParent = async (itemId: number): Promise<IItem | null> => {
    if (itemId) {
        try {
            const parent = await dataAPI.getJSON<ItemDTO>(
                `Items/${itemId}/Parent`,
            )
            if (parent) {
                return {
                    id: parent.Id,
                    number: parent.Number,
                    title: parent.Label,
                }
            } else {
                return null
            }
        } catch (error) {
            if (error instanceof Response) {
                if (error.status === 404) {
                    return null
                }
                const errorMessage = formatString(
                    Exceptions.AnErrorOccurredWhileFetchingParents,
                    itemId,
                )
                throw await RequestErrorDataApi.create(
                    errorMessage,
                    error.status,
                    error,
                )
            }
            throw error
        }
    } else {
        return null
    }
}
